const header = document.querySelector('sticky-header');
let lastScroll = 0;

window.addEventListener('scroll', () => {
  const currentScroll = window.scrollY;
  const headerHeight = header.offsetHeight;

  if (currentScroll < lastScroll) {
    document.documentElement.style.setProperty('--header-top', `${headerHeight}px`);
  } else {
    document.documentElement.style.setProperty('--header-top', `0px`);
  }

  lastScroll = currentScroll;
});